import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { CanserModel } from 'src/app/models/CanserModel';
import { CanserService } from 'src/app/services/CanserService';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';

@Component({
  selector: 'app-doctor-observation',
  templateUrl: './doctor-observation.component.html',
  styleUrls: ['./doctor-observation.component.css']
})
export class DoctorObservationComponent implements OnInit {
  Patientcode = '';
  Patientname = '';
  visitdate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  birthDate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  dateEntry1 =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
  paAge = 0;
  gender = ''
  cancerID = '';
  pathology ='';
  cancerlist : CanserModel[]=[];
  disablepharnacy = false;
  @Output() submitClicked = new EventEmitter<any>();
  constructor(public CanserService : CanserService,
    public storage: LocalStorageService,
    private dialogref: MatDialog,
    public dataBankService : DataBankService,
    public patient :DatabankModel,
    )  {
      this.retrievePatient();
    }

  ngOnInit(): void {
    this.retriveCancersLookupTop();
    this.Patientcode = this.storage.retrieve('stgPatientCode');
    this.Patientname = this.storage.retrieve('stgPatientName');
    this.visitdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');

    this.retrievePatient();
    if(this.storage.retrieve('stgGroup') =='4'){
      this.disablepharnacy = true;
    }
  }

  retriveCancersLookupTop() {
    this.CanserService.getCancerLookupTop().subscribe((data:CanserModel[])=>{
  for(let i=0 ; i <data.length; i++)
  {this.cancerlist[i]=data[i];}
 })
  }
   retrievePatient() {
    debugger;
      this.dataBankService.getPatient(this.Patientcode, this.storage.retrieve('stgCompCode'))
        .subscribe((data: DatabankModel) => {

          this.storage.store('stgPatientCode',data.patientCode)
          this.storage.store('stgPatientName',data.patientFName);
          this.Patientname = data.patientFName;
          this.storage.store('stgcancerID',data.cancerID);
        this.paAge = Number(data.ageYear);
        this.birthDate =formatDate(data.birthDate,'yyyy-MM-dd','en') ;
        this.gender = data.gender;

        this.cancerID = data.cancerID;
        this.dateEntry1 = formatDate(data.dateEntry,'yyyy-MM-dd','en');

      });

  }
  Retrive_All(){
   debugger;
    this.storage.store('stgPatientCode', this.Patientcode);
    this.retrievePatient()
    window.location.reload();
  }
  OpenPatientDialog(){
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent,
    {
      data: {
        dataKey: this.patient
      }
  });
  dialogRef.afterClosed().subscribe(result => {
  });

  const dialogSubmitSubscription =
     dialogRef.componentInstance.submitClicked.subscribe(result => {
      this.Patientcode = result.patientCode;
      this.storage.store('stgPatientCode', this.Patientcode);

      this.retrievePatient();
      window.location.reload();
    });

}
PutPatient(){
    //this.storage.store('stgPatientCode','20230759');
}
OpenPreparation() {
  this.storage.store('stgPatientCode',this.Patientcode);
///this.storage.store('stgDoctorCode','');
 // this.storage.store('stgDocumentDate',this.patdate);



}
}
